import React from 'react';

/**
 * Componente de alerta para mostrar que los admins no pueden editar
 */
const AdminReadOnlyAlert = ({ tipo = 'visita' }) => {
  return (
    <div className="mb-4 p-4 bg-yellow-200 rounded-lg">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg 
            className="h-5 w-5 text-amber-500" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-amber-800">
            Solo lectura - Usuario Administrador
          </h3>
          <p className="mt-1 text-sm text-amber-700">
            Como administrador, puedes visualizar todas las {tipo}s pero no puedes crear ni modificarlas. 
            Solo los comerciales pueden crear y editar {tipo}s.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminReadOnlyAlert;
